import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';
import { downloadProtectedFile } from '../../../app/utils/fileDownloads';

export default function MyReceipts() {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [downloadingId, setDownloadingId] = useState(null);

  useEffect(() => {
    axios.get('/api/customer/payments')
      .then((r) => setPayments(r.data.filter((payment) => payment.status === 'verified')))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const downloadReceipt = async (paymentId) => {
    setDownloadingId(paymentId);
    try {
      await downloadProtectedFile(`/api/customer/payments/${paymentId}/receipt`, `receipt-${paymentId}.pdf`);
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to download receipt');
    } finally {
      setDownloadingId(null);
    }
  };

  return (
    <div>
      <div className="page-header">
        <Link to="/home" className="back-btn">&larr;</Link>
        <h1>My Receipts</h1>
      </div>
      <div className="page-content">
        {loading ? (
          <div className="loading-center"><div className="spinner spinner-dark" /></div>
        ) : payments.length === 0 ? (
          <div className="empty-state">
            <div className="icon">Receipt</div>
            <p style={{ fontWeight: 600 }}>No receipts yet</p>
            <p>Receipts appear after payment is verified.</p>
          </div>
        ) : payments.map((payment) => (
          <div className="card" key={payment.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12 }}>
            <div>
              <p style={{ fontWeight: 700, fontSize: 14 }}>Receipt #{payment.id.toString().padStart(6, '0')}</p>
              <p style={{ fontSize: 12, color: 'var(--muted)' }}>
                {new Date(payment.created_at).toLocaleDateString('en-GH', { year: 'numeric', month: 'short', day: 'numeric' })}
              </p>
              <p style={{ fontSize: 13, color: 'var(--steel-soft)', fontWeight: 600, marginTop: 2 }}>
                GHS {parseFloat(payment.amount).toFixed(2)}
              </p>
            </div>
            <button
              type="button"
              className="btn btn-outline btn-sm"
              onClick={() => downloadReceipt(payment.id)}
              disabled={downloadingId === payment.id}
            >
              {downloadingId === payment.id ? 'Downloading...' : 'Download'}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
